import React from 'react';

import {
  ModalDialog,
  Typography
} from 'e100-react-components';

import { useIntl } from 'react-intl';

import { useIsDeletingFavouriteBrandsLoading } from 'entities/brands';

export const FavouriteBrandsDeleteModal = ({
  open = false,
  onCancel,
  onOk
}: FavouriteBrandsDeleteModalProps) => {
  const { formatMessage } = useIntl();
  const isDeletingFavouriteBrandsLoading = useIsDeletingFavouriteBrandsLoading();

  return (
    <ModalDialog
      open={open}
      title={formatMessage({ id: 'deleteFromFavorites' })}
      labelOk={formatMessage({ id: 'delete' })}
      onOk={onOk}
      labelCancel={formatMessage({ id: 'feedbackModal.cancel' })}
      onClose={onCancel}
      fullWidth
      maxWidth={'sm'}
      isLoading={isDeletingFavouriteBrandsLoading}
    >
      <Typography>{formatMessage({ id: 'favouriteBrands.deleteModal.message' })}</Typography>
    </ModalDialog>
  );
};

interface FavouriteBrandsDeleteModalProps {
  open?: boolean;
  onCancel?: () => void;
  onOk?: () => void;
}
